import TableCellFilted from '../common/componentUI/TableCellFilted';
import resultsReviewDispatcher from './action';
import GroupToolbar from './component/GroupToolbar';
import {
  COLUMN_RESULTS_REVIEW,
  HS_RESULTS_REVIEW_DISPLAY_STATUS,
  HS_RESULTS_REVIEW_STATUS_COLORS,
  RESULTS_REVIEW_FUT_STATUS,
  RESULTS_REVIEW_STATUS,
} from './constants';
import { EditIcon, ExportIcon, NoDataEcommerce } from '@/assets/svg';
import { ROLE_TYPES } from '@/constants/roles';
import { urlLabel } from '@/enum/PermissionEnum';
import { handleSelectAll } from '@/helpers';
import customToast from '@/new-components/CustomNotification';
import CustomPaperContainer from '@/new-components/CustomPaperContainer';
import CustomHeader from '@/new-components/CustomPaperContainer/CustomHeader';
import { CustomStatusComponent } from '@/new-components/CustomStatusComponent';
import CustomTable from '@/new-components/CustomTable';
import CustomTooltip from '@/new-components/CustomTooltip';
import {
  Button,
  TableCell,
  TableHead,
  TableRow,
  withStyles,
} from '@material-ui/core';
import { debounce } from 'lodash';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

// import data from './fake.json';

const ReviewButton = withStyles((theme) => ({
  root: {
    padding: '8px 12px',
    minWidth: 93,
  },
}))(Button);

const ResultsReview = () => {
  const history = useHistory();
  const { list: data, paging } = useSelector(
    (state) => state.resultsReviewBackroom
  );
  const userInfo = useSelector((state) => state.auth.userInfo);
  const isDoctor = userInfo?.roleName === ROLE_TYPES.DOCTOR;
  const isAdminSide =
    userInfo?.roleName === ROLE_TYPES.SUPER_ADMIN ||
    userInfo?.roleName === ROLE_TYPES.SYSTEM_ADMIN;
  const defaultReviewStatuses = isDoctor ? ['ReviewRequired'] : [];

  const [sortOption, setSortOption] = useState({});
  const [searchKey, setSearchKey] = useState('');

  const [screeningDate, setScreeningDate] = useState([]);
  const [signedMonth, setSignedMonth] = useState([]);
  const [reviewerStatus, setReviewerStatus] = useState(defaultReviewStatuses);
  const [assignedDoctors, setAssignedDoctors] = useState([]);
  const [futStatus, setFutStatus] = useState([]);
  const [filterOption, setFilterOption] = useState(
    isDoctor ? { reviewStatuses: ['ReviewRequired'] } : {}
  );
  const tableColumns = useMemo(
    () =>
      isAdminSide
        ? COLUMN_RESULTS_REVIEW
        : COLUMN_RESULTS_REVIEW.filter(
            (column) => column.stateValue !== 'doctorAssigned'
          ),
    [isAdminSide]
  );
  const onFilterOptionChange = (key) => (e, newValue) => {
    let value = e.target.value;

    switch (key) {
      case 'reviewStatuses':
        value = handleSelectAll(
          value,
          RESULTS_REVIEW_STATUS.map((item) => item.key),
          reviewerStatus
        );
        setReviewerStatus(value);
        break;
      case 'backroomStatuses':
        value = handleSelectAll(
          value,
          RESULTS_REVIEW_FUT_STATUS.map((item) => item.key),
          futStatus
        );
        setFutStatus(value);
        break;
      default:
        break;
    }

    setFilterOption({
      ...filterOption,
      [key]: value,
    });
  };

  const onResetFilterOps = () => {
    setReviewerStatus(defaultReviewStatuses);
    setAssignedDoctors([]);
    setFutStatus([]);
    setFilterOption(isDoctor ? { reviewStatuses: ['ReviewRequired'] } : {});
    setScreeningDate([]);
    setSignedMonth([]);
  };

  const fetchData = async (
    search = searchKey,
    pagingData = paging,
    sortOptionData = sortOption,
    filterOptionData = filterOption
  ) => {
    resultsReviewDispatcher.getData(
      search,
      pagingData,
      sortOptionData,
      filterOptionData
    );
  };

  const debounceLoadData = useCallback(
    debounce((searchKey, paging, sortOption, filterOption) => {
      fetchData(
        searchKey,
        {
          pageIndex: 0,
          pageSize: paging.pageSize,
        },
        sortOption,
        filterOption
      );
    }, 500),
    []
  );

  const onExportExcel = () => {
    if (data.length === 0) {
      return customToast(
        'error',
        'There is no data available to export the excel file'
      );
    }
    let params = {
      ...sortOption,
      ...filterOption,
      search: searchKey,
    };

    resultsReviewDispatcher.getExportExcel(params);
  };

  useEffect(() => {
    debounceLoadData(searchKey, paging, sortOption, filterOption);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchKey, sortOption, filterOption]);

  useEffect(() => {
    return () => {
      resultsReviewDispatcher.resetData();
    };
  }, []);

  const TableHeader = () => (
    <TableHead>
      <TableRow>
        {tableColumns.map((item) =>
          item.sortBy ? (
            <TableCellFilted
              key={item.stateValue}
              label={item.label}
              stateValue={item.stateValue}
              sortBy="Date"
              sortOption={sortOption}
              onSortChange={() => {
                let newSortOption = {
                  sortBy: 'BookedApptDate',
                  orderBy: sortOption.orderBy !== 'Asc' ? 'Asc' : 'Desc',
                };
                setSortOption(newSortOption);
              }}
              style={{
                minWidth: item.minWidth || 'unset',
                width: item.width || 'unset',
              }}
              isHidden={false}
            />
          ) : (
            <TableCellFilted
              key={item.stateValue}
              label={item.label}
              stateValue={item.stateValue}
              style={{
                minWidth: item.minWidth || 'unset',
                width: item.width || 'unset',
              }}
              isHidden={false}
            />
          )
        )}
      </TableRow>
    </TableHead>
  );

  const renderTableBody = (row, index) => {
    return (
      <>
        {/* <TableCell>{index + 1 || '—'}</TableCell> */}
        <TableCell>
          <CustomTooltip content={row.name || '—'} />
        </TableCell>
        <TableCell>
          <CustomTooltip content={row.identityNumber || '—'} />
        </TableCell>
        <TableCell>
          {row.dateOfUpload
            ? moment(row.dateOfUpload).utc().format('DD/MM/YYYY')
            : '—'}
        </TableCell>
        <TableCell>
          {row.screeningDate
            ? moment(row.screeningDate).utc().format('DD/MM/YYYY')
            : '—'}
        </TableCell>
        {isAdminSide && (
          <TableCell>
            <CustomTooltip content={row.assignedDoctorName || '—'} />
          </TableCell>
        )}
        <TableCell>
          {row.reviewStatus ? (
            <CustomStatusComponent
              filterList={HS_RESULTS_REVIEW_DISPLAY_STATUS}
              filterListColor={HS_RESULTS_REVIEW_STATUS_COLORS}
              status={row.reviewStatus}
            />
          ) : (
            '—'
          )}
        </TableCell>
        {/* <TableCell>
          {row.backroomStatus ? (
            <CustomStatusComponent
              filterList={HS_RESULTS_REVIEW_DISPLAY_STATUS}
              filterListColor={HS_RESULTS_REVIEW_STATUS_COLORS}
              status={row.backroomStatus}
            />
          ) : (
            '—'
          )}
        </TableCell> */}
        <TableCell>
          <CustomTooltip content={row.lastSignedBy || '—'} />
        </TableCell>
        <TableCell>
          {row.signedOn ? moment(row.signedOn).utc().format('DD/MM/YYYY') : '—'}
        </TableCell>
        <TableCell>
          {row.timeSigned
            ? moment(row.timeSigned, 'HH:mm:ss').format('h:mm A')
            : '—'}
        </TableCell>
        <TableCell>
          <ReviewButton
            startIcon={<EditIcon />}
            color="primary"
            variant="contained"
            onClick={() => {
              const patientName = row.name
                ? encodeURIComponent(row.name.replace(/\s+/g, '-'))
                : 'unknown';
              const url = `/${urlLabel.resultsReviewDetail.replace(
                ':name',
                patientName
              )}?paxScreeningId=${row.paxScreeningId}&reviewId=${
                row.id
              }&backroomStatus=${row.backroomStatus}`;
              history.push(url);
            }}
          >
            Review
          </ReviewButton>
        </TableCell>
      </>
    );
  };

  return (
    <>
      <CustomPaperContainer
        header={
          <CustomHeader
            searchPlaceholder=" Search by name or NRIC..."
            title="Results Review"
            setSearchKey={setSearchKey}
            searchKey={searchKey}
            filterOption={filterOption}
            setFilterOption={setFilterOption}
            sortOption={sortOption}
            fetchData={fetchData}
            renderToolbar={() => (
              <GroupToolbar
                filterOption={filterOption}
                setFilterOption={setFilterOption}
                onFilterOptionChange={onFilterOptionChange}
                onResetFilterOps={onResetFilterOps}
                reviewerStatus={reviewerStatus}
                assignedDoctors={assignedDoctors}
                setAssignedDoctors={setAssignedDoctors}
                isAdminSide={isAdminSide}
                futStatus={futStatus}
                screeningDate={screeningDate}
                setScreeningDate={setScreeningDate}
                signedMonth={signedMonth}
                setSignedMonth={setSignedMonth}
              />
            )}
            renderButton={() => (
              <>
                <Button
                  color="primary"
                  variant="outlined"
                  startIcon={<ExportIcon width={20} height={20} />}
                  onClick={onExportExcel}
                >
                  Export
                </Button>
              </>
            )}
          />
        }
      >
        <CustomTable
          data={data}
          paging={paging}
          header={TableHeader}
          renderRow={(row, i) => renderTableBody(row, i)}
          noDataHelperText="No follow-up test result"
          noDataHelperSubText="Please come back at another time."
          Icon={NoDataEcommerce}
          totalCols={tableColumns.length}
          fetchData={fetchData}
        />
      </CustomPaperContainer>
    </>
  );
};

export default ResultsReview;
